import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReviewerService {

  private workflowCaseIdSubject = new BehaviorSubject<number | null>(null);
  public currentWorkflowCaseId$ = this.workflowCaseIdSubject.asObservable();

  private reviewerSubject = new BehaviorSubject<string>('AHR');
  public reviewer$ = this.reviewerSubject.asObservable();

  constructor() { }

  updateWorkflowCaseId(id: number | null) {
    this.workflowCaseIdSubject.next(id);
  }

  updateReviewer(reviewer: string) {
    this.reviewerSubject.next(reviewer);
  }

}
